export const rewardfulUrl = 'https://r.wdfl.co/rw.js';
export const rewardfulId = '67824a';
export const rewardfulDataAttribute = 'data-rewardful';
export const rewardfulFunction = `
(function(w,r){w._rwq=r;w[r]=w[r]||function(){(w[r].q=w[r].q||[]).push(arguments)}})(window,'rewardful');
`;
